// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./+not-found.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/+not-found.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/_layout.tsx"); } },
  "./alim-talepleri.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/alim-talepleri.tsx"); } },
  "./ayarlar.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/ayarlar.tsx"); } },
  "./bildirimler.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/bildirimler.tsx"); } },
  "./blog/[yol].tsx": { enumerable: true, get() { return import("/opt/build/repo/app/blog/[yol].tsx"); } },
  "./blog/index.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/blog/index.tsx"); } },
  "./cerezler.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/cerezler.tsx"); } },
  "./favoriler.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/favoriler.tsx"); } },
  "./giris.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/giris.tsx"); } },
  "./gizlilik-politikasi.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/gizlilik-politikasi.tsx"); } },
  "./ilan-duzenle.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/ilan-duzenle.tsx"); } },
  "./ilan-ver.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/ilan-ver.tsx"); } },
  "./ilan/[id].tsx": { enumerable: true, get() { return import("/opt/build/repo/app/ilan/[id].tsx"); } },
  "./index.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/index.tsx"); } },
  "./kategori/[...yol].tsx": { enumerable: true, get() { return import("/opt/build/repo/app/kategori/[...yol].tsx"); } },
  "./kayit.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/kayit.tsx"); } },
  "./kesfet.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/kesfet.tsx"); } },
  "./kullanim-sartlari.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/kullanim-sartlari.tsx"); } },
  "./mesajlar.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/mesajlar.tsx"); } },
  "./nasil-calisir.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/nasil-calisir.tsx"); } },
  "./profil.tsx": { enumerable: true, get() { return import("/opt/build/repo/app/profil.tsx"); } },
  "./satici/[id].tsx": { enumerable: true, get() { return import("/opt/build/repo/app/satici/[id].tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;